import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
  useLocation,
} from "react-router-dom";
import SignIn from "../pages/auth/SignIn";
import Dashboard from "../pages/dashboard/Dashboard";
import Moderation from "../pages/moderation/ModerationList";
import Resources from "../pages/resources/ResourcesList";
import UserManagement from "../pages/usermanagement/UserManagement";
import ProtectedRoutes from "./ProtectedRoutes";
import Header from "../pages/common/Header";
import SideMenu from "../pages/common/SideMenu";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/PasswordSetup";
import Contribute from "../pages/contribute/ContributeList";
import Community from "../pages/community/CommunityList";
import EditContributeTip from "../pages/contribute/EditContributeTip";
import EditCommunityPosts from "../pages/community/EditCommunityPost";
import TemplateList from "../pages/survey/TemplatesList";
import SearchLogList from "../pages/searchanalytics/SearchLogList";
import SurveyList from "../pages/survey/SurveyList";
import OptInFeedbackList from "../pages/optinfeedback/OptInFeedbackList";
import OptInFeedbackDetail from "../pages/optinfeedback/OptInFeedbackDetail";

const Layout = () => (
  <>
    <Header />
    <div className="app-container">
      <SideMenu />
      <main>
      <div className="inner-body w-calc-226px ms-[226px] mt-[81px]  overflow-y-auto mih-calc-100">
      <Outlet />
        </div>
      </main>
    </div>
  </>
);

const Navigation = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/signin") {
      localStorage.clear();
    }
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/resetPassword/:token?" element={<ResetPassword />} />
      <Route
        path="/"
        element={
          <ProtectedRoutes>
            <Layout />
          </ProtectedRoutes>
        }
      >
        <Route path="home" element={<Dashboard />} />
        <Route path="moderation" element={<Moderation />} />
        <Route path="resources" element={<Resources />} />
        <Route path="userManagement" element={<UserManagement />} />
        <Route path="contribute" element={<Contribute />} />
        <Route path="community" element={<Community />} />
        <Route path="contribute/EditContributeTip" element={<EditContributeTip />} />
        <Route path="community/EditCommunityPosts" element={<EditCommunityPosts />} />
        {/* <Route path="survey" element={<TemplateList />} /> */}
        <Route path="survey" element={<SurveyList />} />
        <Route path="searchAnalytics" element={<SearchLogList />} />
        <Route path="optinFeedback" element={<OptInFeedbackList />} />
        <Route path="optinFeedback/detail" element={<OptInFeedbackDetail />} />



      </Route>
      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
};

const AppRouter = () => (
  <Router>
    <Navigation />
  </Router>
);

export default AppRouter;
